import { forwardRef } from 'react';
import type { HTMLAttributes } from 'react';
import { cx } from '../utils/cx.js';
import styles from './Spinner.module.css';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface SpinnerProps extends HTMLAttributes<HTMLSpanElement> {
  size?: SpinnerSize;
  /** Accessible label; the spinner otherwise carries no text. */
  'aria-label'?: string;
}

export const Spinner = forwardRef<HTMLSpanElement, SpinnerProps>(function Spinner(
  { size = 'md', className, 'aria-label': ariaLabel = 'Loading', ...rest },
  ref,
) {
  return (
    <span
      ref={ref}
      role="status"
      aria-label={ariaLabel}
      className={cx(styles.spinner, styles[size], className)}
      {...rest}
    />
  );
});
